<template>
  <div :class="`message-container ${theme.isDark ? 'message-container_dark' : null}`" v-if="messages.length !== 0">
    <Note
      v-for="message in messages"
      :key="message.id"
      :author="`${message.fname} ${message.lname}`"
      :text="message.message"
      :created="message.createdAt"
      :deleteMessage="() => deleteFunction(message.id)"
    />
  </div>
  <div v-else :class="`message-container message-container_empty ${theme.isDark ? 'message-container_dark' : null}`" >
    <p>{{ emptyText }}</p>
  </div>
</template>

<script>
import Note from "./Note";

export default {
  name: "NoteContainer",
  inject: ['theme'],
  components: {
    Note,
  },
  props: {
    messages: Array,
    emptyText: String,
    deleteFunction: Function,
  },
};
</script>
